export * from './skyscraper5.component';